import { useState } from "react";
import { Star, Feather } from "lucide-react";
import { Chip, ListShell, PersonRow, fmtMelb, matches } from "./shared";
import { useTeamReport } from "./useTeamReport";

const BADGE = { rising_star_3x6: ["Rising Star", Star], eagle: ["Eagle", Feather] };

export default function StarsView({ scope, q, rowProps }) {
  const [kind, setKind] = useState("either");
  const data = useTeamReport("stars", { scope, kind });
  const rows = data ? data.rows.filter((r) => matches(r, q)) : null;
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        <Chip active={kind === "either"} onClick={() => setKind("either")} testid="stars-filter-either">Either</Chip>
        <Chip active={kind === "rising_star"} onClick={() => setKind("rising_star")} testid="stars-filter-rising">Rising Star</Chip>
        <Chip active={kind === "eagle"} onClick={() => setKind("eagle")} testid="stars-filter-eagle">Eagle</Chip>
      </div>
      <p className="text-[11px] text-slate-500">Only partners who are currently qualified are shown.</p>
      <ListShell rows={rows} testid="stars-list" empty={q ? "No one matches your search." : "No one is currently qualified for this filter."}>
        {(rows || []).map((r) => (
          <PersonRow key={r.id} u={r} prefix="stars" {...rowProps}>
            <div className="flex flex-wrap gap-1.5 mt-1.5">
              {r.badges.map((b) => {
                const [label, Icon] = BADGE[b.id];
                return (
                  <span key={b.id} data-testid={`stars-badge-${b.id}-${r.id}`}
                        className="inline-flex items-center gap-1 rounded-full bg-[#C9A961]/15 text-[#6B5A1D] px-2 py-0.5 text-[11px] font-medium">
                    <Icon className="w-3 h-3" />{label}{b.since ? ` · since ${fmtMelb(b.since)}` : ""}
                  </span>
                );
              })}
            </div>
          </PersonRow>
        ))}
      </ListShell>
    </div>
  );
}
